import React, {Component} from "react"

import {perkbox, greys} from "@irati/ui/src/global/colors"
import Count from "@irati/ui/src/Count"

import NumberAndText from "../NumberAndText"
import {Flex, StyledCount, DesktopNumberAndText, MobileSignedUpAndRemaining} from "./styled"

interface Props {
  totalLicenses: number,
  numberActivated: number
}

class SignedUpAndRemaining extends Component<Props> {
  render() {
    const {totalLicenses, numberActivated} = this.props
    const remaining = totalLicenses - numberActivated
    const activatedPercent = Math.round(numberActivated / totalLicenses * 100)
    const remainingPercent = 100 - activatedPercent

    return (
      <>
        <Flex>
          <div>
            <DesktopNumberAndText>
              <NumberAndText number={numberActivated} text="medical.reports.employees.signedUp" />
            </DesktopNumberAndText>
            <Count color={perkbox.greenBlue} textColor={greys.white}>{activatedPercent}%</Count>
          </div>
          <div>
            <StyledCount color={perkbox.greenBlue} textColor={greys.white}>{remainingPercent}%</StyledCount>
            <DesktopNumberAndText>
              <NumberAndText number={remaining} text="medical.reports.employees.remaining" />
            </DesktopNumberAndText>
          </div>
        </Flex>
        <MobileSignedUpAndRemaining>
          <NumberAndText number={numberActivated} text="medical.reports.employees.signedUp" />
          <NumberAndText number={remaining} text="medical.reports.employees.remaining" />
        </MobileSignedUpAndRemaining>
      </>
    )
  }
}

export default SignedUpAndRemaining
